export default function printMovement(startDate, endDate, idCategoria = "") {
  const token = localStorage.getItem("token");
  printMovementProduct(token, startDate, endDate, idCategoria)
}
function printMovementProduct(token, startDate, endDate, idCategoria) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/produtos-logs/find/product/per/period?auth=${token}&startDate=${startDate}&endDate=${endDate}&idCategoria=${idCategoria || ""}`
  );
}
